// shadcn-flavored Skeleton (manual install per ADR-025).
import * as React from 'react';
import { cn } from '../../lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): React.ReactNode {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className={cn('animate-pulse rounded-sm bg-cream', className)}
      {...props}
    />
  );
}

export { Skeleton };
